import { useCallback } from 'react';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { useCreateWidgetMutation, useUpdateWidgetMutation } from '../../../../redux/api/fymAPI';
import { useEditorSaves } from '../saves/useEditorSaves';
import { rawDataOfWidget } from './rawDataOfWidget';

interface UseBlockActionsProps {
  accountId: number;
  smartLinkId: number;
  onError: () => void;
}

/** The eye and Duplicate of a row (design a2). Each one is one call; the answer replaces the page. */
export function useBlockActions({ accountId, smartLinkId, onError }: UseBlockActionsProps) {
  const [updateWidget] = useUpdateWidgetMutation();
  const [createWidget] = useCreateWidgetMutation();
  const saves = useEditorSaves();

  const toggleHidden = useCallback(
    (widget: SerializedWidget) => {
      const call = updateWidget({
        accountId,
        smartLinkId,
        widgetUUID: widget.uuid,
        position: widget.position,
        type: widget.type,
        hidden: widget.hidden !== true,
      }).unwrap();
      (saves?.track(call) ?? call).catch(onError);
    },
    [accountId, onError, saves, smartLinkId, updateWidget]
  );

  const duplicate = useCallback(
    (widget: SerializedWidget) => {
      const data = rawDataOfWidget(widget);
      if (data === null) {
        return;
      }
      const call = createWidget({
        accountId,
        smartLinkId,
        type: widget.type,
        data,
        position: widget.position + 1,
        hidden: widget.hidden === true ? true : undefined,
      }).unwrap();
      (saves?.track(call) ?? call).catch(onError);
    },
    [accountId, createWidget, onError, saves, smartLinkId]
  );

  return { toggleHidden, duplicate };
}
